export const DEFAULT_STATE = {
  authenticated: false,
  profile: null,
  loading: false
}
